import script from "./ProcessFlowEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessFlowEditor.vue?vue&type=script&setup=true&lang=js"

import "./ProcessFlowEditor.vue?vue&type=style&index=0&id=40c94a5c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c94a5c"]])

export default __exports__